import React from "react";

const NotFound: React.FC = () => {
  return (
    <div className="p-4 text-center">
      <h2 className="text-3xl font-bold">404</h2>
      <p className="text-lg">Page Not Found</p>
      <a href="/" className="text-blue-500 hover:underline">
        Go to Home
      </a>
    </div>
  );
};

export default NotFound;
